import styled, { DefaultTheme } from 'styled-components';

export const LogoWrapper = styled.img`
    height: 11rem;
    width: 18.75rem;
    object-fit: contain;
`;

export const ErrorTitle = styled.h1<{ errorTheme: DefaultTheme }>(
    ({ errorTheme }) => `
        color: ${errorTheme.sections.page.a};
        font-size: 2rem;
    `,
);

export const ErrorBody = styled.h3<{ errorTheme: DefaultTheme }>(
    ({ errorTheme }) => `
        color: ${errorTheme.sections.page.b};
        font-size: 1.5rem;
    `,
);

export const ErrorFooter = styled.pre<{ errorTheme: DefaultTheme }>(
    ({ errorTheme }) => `
        color: ${errorTheme.sections.page.c};
        font-size: 1rem;
    `,
);

export const ErrorWrapper = styled.div<{
    errorTheme: DefaultTheme;
}>(
    ({ errorTheme }) => `
        position: absolute;
        gap: 1rem;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: ${errorTheme.sections.page.background};
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 2rem;

        ${LogoWrapper}, ${ErrorTitle}, ${ErrorBody} {
            margin-bottom: 2rem;
        }

        @media screen and (max-width: 49rem) {

            ${LogoWrapper} {
                height: 7.25rem;
                width: 12.375rem;
            }

            ${ErrorTitle} {
                font-size: 1.625rem;
            }

            ${ErrorBody} {
                font-size: 1.125rem;
            }

            ${ErrorFooter} {
                font-size: 0.9rem;
            }
        }
    `,
);
